import { Technician } from "@/models/Technician";
import { fullNameFormatter } from "@/utils/formatters";
import { technicianUtils } from "@puls/puls-general-utils";

export const TechnicianGetters = {
	GET_TECHNICIAN_INITIALS: 'GET_TECHNICIAN_INITIALS',
	IS_TECH_LOADED: 'IS_TECH_LOADED',
	GET_TECHNICIAN_TYPE: 'GET_TECHNICIAN_TYPE',
	GET_DETAILS: 'GET_DETAILS',
	GET_EMAIL: 'GET_EMAIL',
	GET_PHONE: 'GET_PHONE',
	GET_COMPANY_NAME: 'GET_COMPANY_NAME',
	GET_FIRST_NAME: 'GET_FIRST_NAME',
	GET_LAST_NAME: 'GET_LAST_NAME',
	GET_ADDRESS: 'GET_ADDRESS',
	GET_RADIUS: 'GET_RADIUS',
	GET_MARKET_ID: 'GET_MARKET_ID',
	GET_SKILLS_MAP: 'GET_SKILLS_MAP',
	IS_SKILLS_INITED: 'IS_SKILLS_INITED',
	HAS_SELECTED_SKILL: "HAS_SELECTED_SKILL",
	HAS_SELECTED_AREA: "IS_VALID_AREAS_SELECTION",
	GET_SELECTED_AREAS: "GET_SELECTED_AREAS",
	GET_SELECTED_SKILLS: "GET_SELECTED_SKILLS",
	GET_SERVICE_AREAS: 'GET_SERVICE_AREAS',
	IS_VALID_ADDRESS_DATA: "IS_VALID_ADDRESS_DATA",
	IS_SERVICE_PROVIDER: 'IS_SERVICE_PROVIDER',
	IS_LEADGEN_PARTNER: 'IS_LEADGEN_PARTNER',
	FULL_NAME: 'FULL_NAME',
	REMAINING_LEADS_COUNT: 'REMAINING_LEADS_COUNT',
	TECHNICIAN: 'TECHNICIAN',
	GET_ADDRESS_COORDINATES: 'GET_ADDRESS_COORDINATES',
	IS_COMPANY_OWNER: 'IS_COMPANY_OWNER'
}

export default {
	[TechnicianGetters.TECHNICIAN]: (state: Technician): Technician => {
		return state;
	},
	[TechnicianGetters.GET_TECHNICIAN_INITIALS]: (state: Technician): string => {
		const firstInitial = state.first_name[0];
		const lastInitial = state.last_name[0];
		if (!firstInitial || !lastInitial) return '';
		return (`${firstInitial}${lastInitial}`).toUpperCase();
	},
	[TechnicianGetters.IS_TECH_LOADED]: (state: Technician): boolean => {
		return !!state.first_name
	},
	[TechnicianGetters.GET_TECHNICIAN_TYPE]: (state: Technician): number => {
		return state.service_provider_id
	},
	[TechnicianGetters.GET_DETAILS]: (state: Technician): Technician => {
		return state;
	},
	[TechnicianGetters.GET_EMAIL]: (state: Technician): string => {
		return state.email;
	},
	[TechnicianGetters.GET_PHONE]: (state: Technician): string => {
		return state.phone;
	},
	[TechnicianGetters.GET_COMPANY_NAME]: (state: Technician): string => {
		return state.company_name;
	},
	[TechnicianGetters.GET_FIRST_NAME]: (state: Technician): string => {
		return state.first_name;
	},
	[TechnicianGetters.GET_LAST_NAME]: (state: Technician): string => {
		return state.last_name;
	},
	[TechnicianGetters.GET_ADDRESS]: (state: Technician): string => {
		return state.address;
	},
	[TechnicianGetters.GET_RADIUS]: (state: Technician): number => {
		return state.radius;
	},
	[TechnicianGetters.GET_MARKET_ID]: (state: Technician): number => {
		return state.market_id;
	},
	[TechnicianGetters.HAS_SELECTED_SKILL]: (state: Technician): boolean => {
		return !!state.skills.size
	},
	[TechnicianGetters.HAS_SELECTED_AREA]: (state: Technician): boolean => {
		return !!state.service_areas.size
	},
	[TechnicianGetters.GET_SELECTED_SKILLS]: (state: Technician): Set<number> => {
		return state.skills;
	},
	[TechnicianGetters.GET_SELECTED_AREAS]: (state: Technician): Set<number> => {
		return state.service_areas;
	},
	[TechnicianGetters.IS_VALID_ADDRESS_DATA]: (state: Technician): boolean => {
		return !!state.market_id;
	},
	[TechnicianGetters.IS_SERVICE_PROVIDER]: (state: Technician) : boolean => {
		return technicianUtils.isServiceProvider(state.service_provider_id)
	},
	[TechnicianGetters.IS_LEADGEN_PARTNER]: (state: Technician) : boolean => {
		return technicianUtils.isLeadPartner(state.service_provider_id)
	},
	[TechnicianGetters.FULL_NAME]: (state: Technician) : string => {
		return fullNameFormatter(state)
	},
	[TechnicianGetters.REMAINING_LEADS_COUNT]: (state: Technician) : number => {
		return state.remaining_leads_count || 0;
	},
	[TechnicianGetters.GET_ADDRESS_COORDINATES]: (state: Technician): { lat: number, lng: number } | undefined => {
		return state.address_coordinates;
	},
	[TechnicianGetters.IS_COMPANY_OWNER]: (state: Technician): boolean => {
		return state.is_company_owner;
	}
}
